import { render } from "./pageDesign.vue?vue&type=template&id=43c38940&ts=true"
import script from "./pageDesign.vue?vue&type=script&lang=ts"
export * from "./pageDesign.vue?vue&type=script&lang=ts"

import "./pageDesign.vue?vue&type=style&index=0&id=43c38940&lang=scss"

import exportComponent from "/home/ssh/jigoucode/jigou_fe_v5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__